import gql from 'graphql-tag';
import { graphql } from 'react-apollo';
import communityInfoFragment from '../../fragments/community/communityInfo';

import communityChannelConnectionWithSlackSettingsFragment from '../../fragments/community/communityChannelConnectionWithSlackSettings';

export const getCommunityChannelConnectionSlackSettingsQuery = gql`
  query getCommunityChannelsWithSlackSettings($id: ID) {
    community(id: $id) {
      ...communityInfo
      slackSettings {
        slackChannelList {
          id
          name
        }
      }
      ...communityChannelConnectionWithSlackSettings
    }
  }
  ${communityInfoFragment}
  ${communityChannelConnectionWithSlackSettingsFragment}
`;

const getCommunityChannelConnectionSlackSettingsOptions = {
  options: ({ id }) => ({
    variables: {
      id,
    },
    fetchPolicy: 'cache-and-network',
  }),
};

export default graphql(
  getCommunityChannelConnectionSlackSettingsQuery,
  getCommunityChannelConnectionSlackSettingsOptions
);
